/**
 * Constants for menu configuration
 */

/**
 * Maximum number of top-level menu items to display on desktop
 * Items beyond this will be moved to the "more" dropdown
 */
export const NESTED_MENU_MAX_DEPTH = 5;

/**
 * Maximum number of top-level menu items to display on desktop
 * Items beyond this will be moved to the "more" dropdown
 */
export const DESKTOP_MAX_TOP_LEVEL_ITEMS = 4;

/**
 * Maximum number of top-level menu items to display on desktop
 * Items beyond this will be moved to the "more" dropdown
 */
export const DESKTOP_MAX_TOP_LEVEL_ITEMS_XL = 7;

/**
 * Animation timeout for top-level menu dropdowns (faster for better UX)
 * Used for CollapseWithSlide components on desktop top-level menus
 */
export const TOP_LEVEL_MENU_TIMEOUT = 200;

/**
 * Animation timeout for submenu dropdowns (slightly slower for nested content)
 * Used for CollapseWithSlide components on submenu items
 */
export const SUBMENU_TIMEOUT = 300;

/**
 * Animation timeout for mobile menu items
 * Used for Collapse components on mobile menu
 */
export const MOBILE_MENU_TIMEOUT = 400;

/**
 * Indentation multiplier for menu items based on depth
 * Used for padding-left calculations: pl: depth * INDENTATION_MULTIPLIER + BASE_INDENTATION
 */
export const INDENTATION_MULTIPLIER = 1.5;

/**
 * Base indentation for menu items (in addition to depth-based indentation)
 * Used for padding-left calculations: pl: depth * INDENTATION_MULTIPLIER + BASE_INDENTATION
 */
export const BASE_INDENTATION = 0.5;

/**
 * Base font size for menu items
 * Used for font size calculations: Math.max(MIN_FONT_SIZE, BASE_FONT_SIZE - depth * FONT_SIZE_DECREMENT)
 */
export const BASE_FONT_SIZE = 20;

/**
 * Minimum font size for menu items
 * Used for font size calculations: Math.max(MIN_FONT_SIZE, BASE_FONT_SIZE - depth * FONT_SIZE_DECREMENT)
 */
export const MIN_FONT_SIZE = 16;

/**
 * Font size decrement per depth level
 * Used for font size calculations: Math.max(MIN_FONT_SIZE, BASE_FONT_SIZE - depth * FONT_SIZE_DECREMENT)
 */
export const FONT_SIZE_DECREMENT = 2;
